<!--
  - SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
  - SPDX-License-Identifier: AGPL-3.0-or-later
-->

<template>
	<div class="popover-loading-indicator">
		<div class="icon icon-loading popover-loading-indicator__icon" />
	</div>
</template>

<script>
export default {
	name: 'PopoverLoadingIndicator',
}
</script>
